import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import invariant from 'invariant';
import clsx from 'clsx';
import { pickHTMLProps } from 'pick-react-known-prop';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import LayoutContext from '../LayoutProvider/LayoutContext';
import LayoutWebClassicHeader from './LayoutWebClassicHeader';
import LayoutWebClassicMainContent from './LayoutWebClassicMainContent';
var useStyles = makeStyles(function () {
  return (
    /* theme */
    {
      root: {
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        '& main': {
          paddingTop: 96
        }
      },
      content: {
        paddingTop: 156
      }
    }
  );
}, {
  name: 'SxLayoutWebClassic'
});
var LayoutWebClassic = React.forwardRef(function (_ref, ref) {
  var AppHeaderNarrowComponent = _ref.AppHeaderNarrowComponent,
      AppHeaderWideComponent = _ref.AppHeaderWideComponent,
      children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      containerProps = _ref.containerProps,
      footerProps = _ref.footerProps,
      headerProps = _ref.headerProps,
      maxWidth = _ref.maxWidth,
      rest = _objectWithoutProperties(_ref, ["AppHeaderNarrowComponent", "AppHeaderWideComponent", "children", "classes", "className", "containerProps", "footerProps", "headerProps", "maxWidth"]);

  var classes = useStyles({
    classes: pClasses
  });
  var ctx = React.useContext(LayoutContext);
  invariant(ctx, "'LayoutProductionApp' use only inside <LayoutProvider>");
  var appBarActions = ctx.appBarActions,
      appMenu = ctx.appMenu,
      LayoutWebClassicFooter = ctx.footer,
      logo = ctx.logo;
  return React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), React.createElement(LayoutWebClassicHeader, _extends({
    AppHeaderNarrowComponent: AppHeaderNarrowComponent,
    AppHeaderWideComponent: AppHeaderWideComponent,
    appBarActions: appBarActions,
    appMenu: appMenu,
    logo: logo,
    maxWidth: maxWidth,
    ref: ref
  }, headerProps)), React.createElement(Container, _extends({
    maxWidth: maxWidth
  }, containerProps), React.createElement(LayoutWebClassicMainContent, {
    className: classes.content
  }, children)), React.createElement(LayoutWebClassicFooter, _extends({
    maxWidth: maxWidth
  }, footerProps)));
});
LayoutWebClassic.propTypes = {
  AppHeaderNarrowComponent: PropTypes.elementType,
  AppHeaderWideComponent: PropTypes.elementType,
  children: PropTypes.node,
  classes: PropTypes.shape({
    content: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  containerProps: PropTypes.shape({}),
  footerProps: PropTypes.shape({}),
  headerProps: PropTypes.shape({}),
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false])
};
LayoutWebClassic.defaultProps = {
  AppHeaderNarrowComponent: undefined,
  AppHeaderWideComponent: undefined,
  children: null,
  classes: undefined,
  className: undefined,
  containerProps: undefined,
  footerProps: undefined,
  headerProps: undefined,
  maxWidth: false
};
export default LayoutWebClassic;